import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import Chart from './Chart';
import '../App.css';

function App() {

  const [editions, setEditions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(0);
  const [isMenuOpen, setIsMenuOpen] = useState(false); // Estado para controlar se o menu está aberto ou fechado

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen); // Alternar entre aberto e fechado
  };

  return (
    <div className="App">
      <nav className="navbar navbar-dark bg-primary">
        <div className="container">
          <button className="navbar-toggler" type="button" onClick={toggleMenu}>
            <span className="navbar-toggler-icon"></span>
          </button>
          <a className="navbar-brand" href="#">
            <i className="fa d-inline fa-lg fa-circle-o"></i>
            <b>Rhymes Score</b>
          </a>
          <div className={`collapse navbar-collapse ${isMenuOpen ? 'show' : ''}`}>
            <ul className="navbar-nav ml-auto">
              <li className="nav-item">
                <Link className="nav-link" to="/">Home</Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link" to="/topbigfour">Top 5 - Big Four - São Paulo SP</Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link" to="/rankhype">Ranking do Hype - Big Four - São Paulo SP</Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link" to="/about">Sobre Nós</Link>
              </li>
            </ul>
          </div>
        </div>
      </nav>

      {/* Main content */}
      <div className="main-content py-5">
        <div className="py-5">
          <div className="container">
            <div className="row">
              <div className="col-md-12">
                <h2 className="editions-title">Top 5 Big Four - São Paulo SP - 2025</h2>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div>
        <Chart />
      </div>

      {/* Footer */}
      <footer>
        <div className="text-center">
          <p className="mb-0">© 2024 Rhymes Score. All rights reserved</p>
        </div>
      </footer>
    </div>
  );
}

export default App;
